import { supabase } from '@/core/database/supabase';
import type { EstimateHeader, EstimateItem, EstimateVersion } from '../types/estimate.types';

function normalizeVersion(row: any): EstimateVersion {
  return {
    id: row.id,
    company_id: row.company_id,
    project_id: row.project_id,
    estimate_id: row.estimate_id,
    version_no: Number(row.version_no || 0),
    snapshot_json: row.snapshot_json,
    total_amount: Number(row.total_amount || 0),
    created_by: row.created_by,
    created_at: row.created_at,
    note: row.note,
  };
}

export const estimateVersionsService = {
  async getByEstimateId(estimateId: string): Promise<EstimateVersion[]> {
    const { data, error } = await supabase
      .from('estimate_versions' as any)
      .select('*')
      .eq('estimate_id', estimateId)
      .order('version_no', { ascending: false });

    if (error) {
      const missingTable = error.code === '42P01' || error.message?.includes('estimate_versions');
      if (missingTable) return [];
      throw error;
    }

    return ((data || []) as any[]).map(normalizeVersion);
  },

  async createSnapshot(params: {
    estimate: EstimateHeader;
    items: EstimateItem[];
    createdBy?: string | null;
    note?: string;
  }): Promise<EstimateVersion> {
    const { estimate, items, createdBy, note } = params;
    const snapshot = {
      estimate,
      items,
      locked_at: new Date().toISOString(),
    };

    const { data, error } = await supabase
      .from('estimate_versions' as any)
      .insert({
        company_id: estimate.company_id,
        project_id: estimate.project_id,
        estimate_id: estimate.id,
        version_no: estimate.version_no || 1,
        snapshot_json: snapshot,
        total_amount: estimate.total_amount || 0,
        created_by: createdBy || null,
        note: note || null,
      })
      .select()
      .single();

    if (error) throw error;
    return normalizeVersion(data);
  },
};
